import React from 'react'

const Tshirt = () => {
  return (
    <div>Tshirt</div>
  )
}

export default Tshirt